"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = void 0;
var React = require("react");
var Icons_1 = require("../../Icons");
var Localization_1 = require("../../Localization");
var Paginator_styles_1 = require("./Paginator.styles");
var Paginator = function (_a) {
    var CurrentPage = _a.CurrentPage, OnPageRequest = _a.OnPageRequest, TotalPages = _a.TotalPages;
    var inputRef = React.createRef();
    var suppressUpDownKeys = function (e) {
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
        }
    };
    var handlePageNumberKeyUp = function (e) {
        if (e.keyCode === 13) {
            var value = Number(e.target.value);
            moveToPage(value);
        }
    };
    var handlePageNumberBlur = function (e) {
        var value = Number(e.target.value);
        if (value !== CurrentPage) {
            moveToPage(value);
        }
    };
    var moveToPage = function (page) {
        var currentPage = setCurrentPage(page);
        inputRef.current.value = currentPage.toString();
        OnPageRequest(currentPage);
    };
    var setCurrentPage = function (page) {
        if (isNaN(page) || page <= 0) {
            return 1;
        }
        return page > TotalPages ? TotalPages : page;
    };
    if (TotalPages > 1) {
        return (React.createElement(Paginator_styles_1.Pagination, null,
            React.createElement(Paginator_styles_1.Spacer, null),
            React.createElement(Paginator_styles_1.Button, { disabled: setCurrentPage(CurrentPage) === 1, "aria-label": Localization_1.strings.Paginator_Action_MoveFirst, title: Localization_1.strings.Paginator_Action_MoveFirst, onClick: function () { return moveToPage(1); } },
                React.createElement(Icons_1.FirstIcon, null)),
            React.createElement(Paginator_styles_1.Button, { disabled: setCurrentPage(CurrentPage) === 1, "aria-label": Localization_1.strings.Paginator_Action_MovePrevious, title: Localization_1.strings.Paginator_Action_MovePrevious, onClick: function () { return moveToPage(CurrentPage - 1); } },
                React.createElement(Icons_1.ChevronLeftIcon, null)),
            React.createElement(Paginator_styles_1.Indicator, null,
                React.createElement(Paginator_styles_1.IndicatorDiv, null, Localization_1.strings.Paginator_Label_Page),
                React.createElement(Paginator_styles_1.Input, { title: Localization_1.strings.Paginator_Label_CurrentPage, onKeyUp: handlePageNumberKeyUp, onKeyDown: suppressUpDownKeys, onBlur: handlePageNumberBlur, "aria-label": Localization_1.strings.Paginator_Label_CurrentPage, min: "1", max: TotalPages, placeholder: "1", type: "number", ref: inputRef, defaultValue: setCurrentPage(CurrentPage).toString() }),
                React.createElement(Paginator_styles_1.IndicatorDiv, null, Localization_1.strings.formatString(Localization_1.strings.Paginator_Label_Of, TotalPages))),
            React.createElement(Paginator_styles_1.Button, { disabled: setCurrentPage(CurrentPage) === TotalPages, "aria-label": Localization_1.strings.Paginator_Action_MoveNext, title: Localization_1.strings.Paginator_Action_MoveNext, onClick: function () { return moveToPage(CurrentPage + 1); } },
                React.createElement(Icons_1.ChevronRightIcon, null)),
            React.createElement(Paginator_styles_1.Button, { disabled: setCurrentPage(CurrentPage) === TotalPages, "aria-label": Localization_1.strings.Paginator_Action_MoveLast, title: Localization_1.strings.Paginator_Action_MoveLast, onClick: function () { return moveToPage(TotalPages); } },
                React.createElement(Icons_1.LastIcon, null))));
    }
    else {
        return null;
    }
};
exports.Paginator = Paginator;
